import { createTheme, rem } from '@mantine/core';

/**
 * Portal look: calm dark-indigo primary, generous radius, Inter.
 * Keep it minimal — most of the "pro" feel comes from spacing and restraint.
 */
export const theme = createTheme({
    fontFamily:
        'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    headings: {
        fontFamily:
            'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
        fontWeight: '650',
    },
    primaryColor: 'indigo',
    primaryShade: 6,
    defaultRadius: 'md',
    cursorType: 'pointer',
    components: {
        Button: {
            defaultProps: { radius: 'md' },
        },
        Card: {
            defaultProps: { radius: 'lg', withBorder: true },
        },
        TextInput: {
            defaultProps: { size: 'md' },
        },
        PasswordInput: {
            defaultProps: { size: 'md' },
        },
        Select: {
            defaultProps: { size: 'md' },
        },
    },
    fontSizes: {
        md: rem(15),
    },
});
